import PropTypes from "prop-types"
import { forwardRef } from "react"

import { cn } from "styles/utils"

const Input = forwardRef(
  (
    {
      className,
      containerClassName,
      error,
      id,
      label,
      labelClassName,
      name,
      placeholder,
      ...props
    },
    ref
  ) => {
    return (
      <div
        className={cn("flex-1 overflow-hidden", containerClassName)}
        role="group"
      >
        {label && (
          <label
            className={cn(
              "text-14 leading-20 mb-6 block font-medium",
              labelClassName
            )}
            htmlFor={id}
          >
            {label}
          </label>
        )}
        <input
          className={cn(
            "border-grey-20 text-grey-65 text-14 leading-24 placeholder:text-grey-35 w-full max-w-full border px-12 py-8 font-medium outline-none focus:border focus:border-black focus:outline-none",
            className
          )}
          id={id}
          name={name}
          placeholder={placeholder ?? (typeof label === "string" ? label : "")}
          ref={ref}
          {...props}
        />
        {error && (
          <p className="text-error text-12 mt-8">{error.message || error}</p>
        )}
      </div>
    )
  }
)

Input.displayName = "Input"

Input.propTypes = {
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelClassName: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
}

export default Input
